import React from 'react';
import { Avatar } from '@mui/material';
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import BadgeIcon from '@mui/icons-material/Badge';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ShieldIcon from '@mui/icons-material/Shield';
import GavelIcon from '@mui/icons-material/Gavel';
import StoreIcon from '@mui/icons-material/Store';
import PrintIcon from '@mui/icons-material/Print';
import SchoolIcon from '@mui/icons-material/School';
export const iconosGrupo = {servicios:'Servicios',juegos:'Juegos / Free Fire',identidad:'Identidad / RENAP',impuestos:'Impuestos / SAT',
  seguridad:'Seguridad / PNC',justicia:'Justicia / OJ',negocio:'Negocio / trámites',impresion:'Impresiones',estudio:'Estudio'};
const icons = {servicios:MiscellaneousServicesIcon,juegos:SportsEsportsIcon,identidad:BadgeIcon,impuestos:AccountBalanceIcon,
  seguridad:ShieldIcon,justicia:GavelIcon,negocio:StoreIcon,impresion:PrintIcon,estudio:SchoolIcon};
export default function RafagaGrupoIcono({grupo,size=42}) {
  const Icon = icons[grupo.icono] || MiscellaneousServicesIcon;
  return <Avatar src={grupo.imagen || undefined} alt={grupo.nombre} variant="rounded"
    sx={{width:size,height:size,bgcolor:'primary.main',p:grupo.imagen ? .5 : 0,'& img':{objectFit:'contain'}}}>
    <Icon sx={{fontSize:size*.6}} />
  </Avatar>;
}
